import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useGlobalStoreContext } from "@/context/globalStoreContext";
import useNavigateLogin from "@/hooks/useNavigateLogin";
import useUserInfo from "@/hooks/useUserInfo";

const whiteList = ["/setting/email"];

const Authorize = (props: { children: ReactNode }) => {
  const store = useGlobalStoreContext();

  const { userInfoContext } = useUserInfo();

  const { pathname } = useLocation();

  const { navigateLogin } = useNavigateLogin();

  console.log(store.load, userInfoContext.userInfo?.email, pathname);

  useEffect(() => {
    if (whiteList.includes(pathname)) {
      return;
    }

    if (store.load && !userInfoContext.userInfo?.email) {
      navigateLogin();
    }
  }, [store.load, userInfoContext.userInfo?.email, pathname, navigateLogin]);

  // if (!store.load) {
  //   return null;
  // }

  return <>{props.children}</>;
};

export default Authorize;
